import React, { useEffect, useState } from 'react';
// import { registerUser } from '../../../_actions/user_actions';
import { registerUser } from '../../../redux/user';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  FormHelperText,
  Modal,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  Grid,
} from '@mui/material';

import { styled, createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
// import logoRy1 from '../../../assets/ry1.png';

import { ORGANIZATION_SERVER } from '../../Config';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
axios.defaults.withCredentials = true;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const theme = createTheme({
  main: 'rgba(0, 0, 0, 0.6)',
  orange: orange[500],
});

const CustomeGrid = styled(Grid)({
  height: '72px',
});

const CustomTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});
const CustomFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});

const pwRegExp = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>/?]).{8,}[^\s]*$/;
// const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email.').required(`What's your email address?`),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters.')
    .matches(pwRegExp, 'Password should contain at least one digit, one character and one punctuation.'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match.')
    .required('Confirm Password is required'),
  group: Yup.string().required('Organization is required'),
  name: Yup.string().max(800).required('Name is required'),
  phonenumber: Yup.string(),
  // .matches(phoneRegExp, {
  //   message: 'Phone number is not valid',
  //   excludeEmptyString: true,
  // }),
});
const defaultValues = {
  name: '',
  email: '',
  role: 'user',
  password: '',
  confirmPassword: '',
  group: '',
  phonenumber: '',
  status: 'approved',
  salt: '',
};

function SignupPage(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const matches = useMediaQuery('(max-width:768px)');
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [visiblePW, setVisiblePW] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [formErrorMessage, setFormErrorMessage] = useState('');
  const [openErrorModal, setOpenErrorModal] = useState(false);
  // const user = useSelector((state) => state.user);

  const onSubmit = async (data, e) => {
    let formData = {
      name: data.name,
      email: data.email,
      role: data.role,
      password: data.password,
      group: data.group,
      phonenumber: data.phonenumber,
      status: 'Waiting for Approval',
    };
    // async request which may result error
    try {
      dispatch(registerUser(formData)).then((res) => {
        if (res.payload.success) {
          navigate('/login');
        } else {
          setFormErrorMessage(res.payload.msg);
          setOpenErrorModal(true);
        }
      });
    } catch (e) {
      // handle your error
    }
  };

  const handleErrorModalClose = () => {
    setFormErrorMessage('');
    setOpenErrorModal(false);
  };

  const onClickCancel = () => {
    navigate('/login');
  };

  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_SERVER}${ORGANIZATION_SERVER}/list`).then((res) => {
      // console.log(res.data);
      setGroupList(res.data);
    });
  }, []);

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        sx={[
          {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: 1,
            position: 'absolute',
          },
          isMobile
            ? {
                height: '100%',
              }
            : {
                height: '700px',
              },
          isMobile
            ? {
                top: '',
              }
            : {
                top: '50%',
              },
          isMobile
            ? {
                msTransform: '',
              }
            : {
                msTransform: 'translateY(-50%)',
              },
          isMobile
            ? {
                transform: '',
              }
            : {
                transform: 'translateY(-50%)',
              },
        ]}
      >
        <Card
          elevation={5}
          sx={[
            isMobile
              ? {
                  width: '100%',
                }
              : {
                  width: '600px',
                },
          ]}
        >
          {/* <CardMedia></CardMedia> */}

          <CardContent sx={{ padding: '20px 20px 0px 20px' }}>
            <Grid container spacing={1}>
              <Grid size={12}>
                <Typography
                  align="center"
                  sx={{
                    fontWeight: '600',
                    fontSize: '40px',
                    color: 'rgba(0,134,255,1.00)',
                    marginBottom: '8px',
                  }}
                >
                  Sign Up
                </Typography>
              </Grid>

              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: 'space-around',
                  alignItems: 'stretch',
                }}
              >
                <CustomeGrid size={9}>
                  <CustomTextField
                    fullWidth
                    required
                    variant="standard"
                    label="ID (Email)"
                    autoComplete="email"
                    {...register('email')}
                    value={watch('email') || ''}
                    error={Boolean(errors.email)}
                    helperText={errors.email?.message}
                    size="small"
                  />
                </CustomeGrid>
                <CustomeGrid size={9}>
                  <CustomTextField
                    fullWidth
                    required
                    variant="standard"
                    label="Password"
                    type={visiblePW ? 'text' : 'password'}
                    {...register('password')}
                    value={watch('password') || ''}
                    error={Boolean(errors.password)}
                    helperText={errors.password?.message}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          onClick={() => {
                            setVisiblePW(!visiblePW);
                          }}
                        >
                          {visiblePW && <VisibilityOffIcon style={{ width: '20px', height: '20px' }} />}
                          {!visiblePW && <VisibilityIcon style={{ width: '20px', height: '20px' }} />}
                        </IconButton>
                      ),
                    }}
                  />
                </CustomeGrid>
                <CustomeGrid size={9}>
                  <CustomTextField
                    fullWidth
                    required
                    variant="standard"
                    label="ConfirmPassword"
                    type="password"
                    {...register('confirmPassword')}
                    value={watch('confirmPassword') || ''}
                    error={Boolean(errors.confirmPassword)}
                    helperText={errors.confirmPassword?.message}
                    size="small"
                  />
                </CustomeGrid>
                <CustomeGrid size={9}>
                  <CustomFormControl variant="outlined" fullWidth style={{ marginTop: '12px' }}>
                    <InputLabel shrink id="select-group-label">
                      Organization
                    </InputLabel>
                    <Select
                      labelId="select-group-label"
                      id="group-select"
                      label="Organization"
                      fullWidth
                      required
                      {...register('group')}
                      value={watch('group') || ''}
                      error={Boolean(errors.group)}
                      size="small"
                    >
                      {groupList.length > 0 &&
                        groupList.map((group) => {
                          return (
                            <MenuItem key={group._id} value={group._id}>
                              {`${group.name} ${group.projectName ? `- ${group.projectName}` : ''}`}
                            </MenuItem>
                          );
                        })}
                    </Select>
                    <FormHelperText style={{ margin: '0px', color: '#d32f2f' }}>{errors.group?.message}</FormHelperText>
                  </CustomFormControl>
                </CustomeGrid>
                <CustomeGrid size={9}>
                  <CustomTextField
                    fullWidth
                    required
                    variant="standard"
                    label="Name"
                    autoComplete="name"
                    {...register('name')}
                    value={watch('name') || ''}
                    error={Boolean(errors.name)}
                    helperText={errors.name?.message}
                    size="small"
                  />
                </CustomeGrid>

                <CustomeGrid size={9}>
                  <CustomTextField
                    fullWidth
                    variant="standard"
                    label="Contact"
                    autoComplete="tel"
                    {...register('phonenumber')}
                    value={watch('phonenumber') || ''}
                    error={Boolean(errors.phonenumber)}
                    helperText={errors.phonenumber?.message}
                    size="small"
                  />
                </CustomeGrid>
              </Grid>
            </Grid>
          </CardContent>

          <CardActions sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, width: '100%' }}>
              <Button type="submit" variant="contained" sx={{ width: '33%', textTransform: 'none' }}>
                Submit
              </Button>
              <Button
                variant="outlined"
                color="error"
                sx={{ width: '33%', textTransform: 'none' }}
                onClick={onClickCancel}
              >
                Cancel
              </Button>
            </Box>
          </CardActions>
        </Card>
      </Box>
      <Modal
        open={openErrorModal}
        onClose={handleErrorModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ErrorOutlineRoundedIcon color="warning" style={{ fontSize: 64 }} />
          <Typography id="modal-modal-title" style={{ margin: 16, fontWeight: 600, fontSize: '24px' }}>
            {formErrorMessage}
          </Typography>

          <Button variant="contained" color="error" size="small" onClick={handleErrorModalClose}>
            OK
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default SignupPage;
